import { Product } from "../components/Products/ProductCard";

export const products: Product[] = [
  {
    id: 1,
    name: "Savoy Cabbage",
    price: 11,
    image:
      "https://images.unsplash.com/photo-1598030343246-eec71cb442c1?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Vegetables"],
  },
  {
    id: 2,
    name: "Organic Cauliflower",
    price: 27.05,
    image:
      "https://images.unsplash.com/photo-1568584711271-4c9c9c6c7c3c?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Meat"],
  },
  {
    id: 3,
    name: "Organic Lentil Sprouts",
    price: 9.05,
    image:
      "https://images.unsplash.com/photo-1515543904379-3d757afe72e4?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Vegetables"],
  },
  {
    id: 4,
    name: "Green Beans – 1 Kg",
    price: 5,
    image:
      "https://images.unsplash.com/photo-1567375698348-5d9d5ae99de0?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Organic Juice"],
  },
  {
    id: 5,
    name: "Green Beans – 1 Kg",
    price: 17.05,
    image:
      "https://images.unsplash.com/photo-1593113646773-028c64a8f1b8?auto=format&fit=crop&w=800&q=80",
    categories: ["Vegetables"],
  },
  {
    id: 6,
    name: "Green Beans – 1 Kg",
    price: 21.05,
    image:
      "https://images.unsplash.com/photo-1566842600175-97dca3dfd925?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Meat", "Vegetables"],
  },
  {
    id: 7,
    name: "Strawberry",
    price: 22,
    oldPrice: 28,
    sale: true,
    image:
      "https://images.unsplash.com/photo-1464965911861-746a04b4bca6?auto=format&fit=crop&w=800&q=80",
    categories: ["Fruits", "Vegetables"],
  },
  {
    id: 8,
    name: "Tomato",
    price: 14,
    oldPrice: 15,
    sale: true,
    image:
      "https://images.unsplash.com/photo-1546094096-0df4bcaaa337?auto=format&fit=crop&w=800&q=80",
    categories: ["Fresh Onion", "Oatmeal"],
  },
  {
    id: 9,
    name: "Organic Lentil Sprouts",
    price: 26,
    image:
      "https://images.unsplash.com/photo-1525662242716-6c0a7b2d0c2f?auto=format&fit=crop&w=800&q=80",
    categories: ["Mushrooms", "Vegetables"],
  },
  {
    id: 10,
    name: "Avocado Hass",
    price: 19,
    oldPrice: 27.05,
    sale: true,
    image:
      "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?auto=format&fit=crop&w=800&q=80",
    categories: ["Canned Organic", "Vegetables"],
  },
  {
    id: 11,
    name: "Organic Cauliflower",
    price: 19,
    image:
      "https://images.unsplash.com/photo-1568584711271-4c9c9c6c7c3c?auto=format&fit=crop&w=800&q=80",
    categories: ["Canned Organic", "Organic Food"],
  },
];